import { AudioPlayerManager } from '../../audioPlayer/audioPlayerManager';
import { textSpeaker } from '../../textSpeaker';
import { ICaptionsItem } from '../../../types/common';

export class TextPlayerProvider {

  private finishChecked: boolean = false;
  private playMode: boolean = false;
  // Local flag instead of Redux state: nothing outside this class ever reads it (was
  // store/phrase-list's isTextPlayerPlay, removed as dead weight — LNG-1709).
  private textPlayerPlay: boolean = false;

  public async play(text: string | undefined, lang?: string) {
    this.textPlayerPlay = true;
    this.finishChecked = false;
    this.playMode = true;
    return textSpeaker.speak(text, lang, false, () => {
      this.playMode = false;
      this.textPlayerPlay = false;
    })
  }

  public async pause() {
    this.finishChecked = true;
    if (this.playMode) {
      textSpeaker.stop();
    }
  }

  public getTargetCaptions(): ICaptionsItem[] {
    return AudioPlayerManager.getInstance().getCaptions();
  }

  public async getActiveTargetCaptionIndex(): Promise<number> {
    const playerManager = AudioPlayerManager.getInstance();
    const currentTime = playerManager.getCurrentTime();
    const {captionIndex} = playerManager.getActiveResult(currentTime);
    return captionIndex;
  }

  public isPaused(): boolean {
    return !this.textPlayerPlay;
  }

  public isPlay(): boolean {
    return this.textPlayerPlay;
  }

  public isFinished(): boolean {
    if (this.finishChecked) {
      return false;
    }
    const result = !this.textPlayerPlay;
    if (result) {
      this.finishChecked = true;
    }
    return result
  }
}
